// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  URL: 'https://api.icibot.net',
  baseURL: 'https://api.icibot.net/v2',
  apiURL: 'https://api.icibot.net/v2/api',
  exApiURL: 'https://api.icibot.net/exapi',
  awsURL: 'https://dm1t7lwkxnxzf.cloudfront.net/',
  wsURL: 'wss://icibot.net/v2',
  hotelId: +localStorage.getItem('hotelId') || 0,
  version: '2025.05.231',

  // ALTINYUNUS
  // URL: 'https://icibotapi.altinyunus.com.tr',
  // baseURL: 'https://icibotapi.altinyunus.com.tr/v2',
  // apiURL: 'https://icibotapi.altinyunus.com.tr/v2/api',
  // awsURL: 'https://b1development.s3.eu-central-1.amazonaws.com/icibotV2/',
  // wsURL: 'wss://icibotapi.altinyunus.com.tr/v2',
  // hotelId: 30,
  // @removed
  // langs: ['tr', 'en', 'ru', 'es', 'fr', 'de', 'ar', 'fa']
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
